module.exports = __webpack_public_path__ + "img/hk.hkf4b6713.svg";